import { render, staticRenderFns } from "./PlafondPanel.vue?vue&type=template&id=0645d2ac&scoped=true"
import script from "./PlafondPanel.vue?vue&type=script&lang=js"
export * from "./PlafondPanel.vue?vue&type=script&lang=js"
import style0 from "./PlafondPanel.vue?vue&type=style&index=0&id=0645d2ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645d2ac",
  null
  
)

export default component.exports